/* NUYU 24 Oct 2026: free gifts leave with whatever unlocked them.
   Every gift the theme adds carries the line property _gift_for = the variant id that unlocked it
   (free gift widget, FUEL+ free kit, pill cutter). After any cart change, a gift line may not hold
   more than that variant's quantity in the cart: if the variant is gone the gift goes, and a gift
   can't outnumber it. Lines without _gift_for (e.g. a partner-code freebie) are never touched.
   Redraws the drawer the same way nuyu-cart-extras.js does; reloads on the /cart page. */
(function () {
  if (window.__nuyuGiftGuard) return;
  window.__nuyuGiftGuard = true;

  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var busy = false;
  var again = false;
  var timer;

  function inner(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function redraw(state) {
    var s = state && state.sections;
    if (!s) return;
    var drawer = document.querySelector('cart-drawer');
    if (s['cart-drawer']) {
      var html = inner(s['cart-drawer'], '.drawer__inner');
      var target = document.querySelector('#CartDrawer .drawer__inner');
      if (html !== null && target) target.innerHTML = html;
      if (drawer && typeof state.item_count === 'number') drawer.classList.toggle('is-empty', state.item_count === 0);
    }
    if (s['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var bh = inner(s['cart-icon-bubble'], '.shopify-section');
      if (bubble && bh !== null) bubble.innerHTML = bh;
    }
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nuyu-gift-guard', cartData: state });
    }
  }

  function check() {
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var held = {};
        cart.items.forEach(function (i) {
          if (!(i.properties && i.properties._gift_for)) held[i.variant_id] = (held[i.variant_id] || 0) + i.quantity;
        });
        var updates = {};
        var n = 0;
        cart.items.forEach(function (i) {
          var parent = i.properties && i.properties._gift_for;
          if (!parent) return;
          var allowed = held[parent] || 0;
          if (i.quantity > allowed) { updates[i.key] = allowed; n++; }
        });
        if (!n) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates, sections: SECTIONS, sections_url: window.location.pathname })
        })
          .then(function (r) { return r.json(); })
          .then(function (state) {
            if (/^\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
            redraw(state);
          });
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; soon(); }
      });
  }

  function soon() {
    clearTimeout(timer);
    timer = setTimeout(check, 400);
  }

  // Any script can change the cart (drawer buttons, cart page, Recurpay, upsells), so watch the
  // network for cart calls rather than hooking each one. Our own update triggers one harmless re-check.
  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (e) {
        if (/\/cart\/(add|change|update|clear)/.test(e.name)) soon();
      });
    }).observe({ type: 'resource', buffered: false });
  } catch (e) {}

  window.addEventListener('pageshow', soon);
  soon();
})();
